import React, { useEffect, useState } from 'react';
import { DateTime, formatInterval, now } from '../utils/date-time';

export default function Elapsed(props: { from: DateTime }) {
    const calcDiff = () => now() - props.from;
    const [diff, setDiff] = useState(calcDiff());

    useEffect(() => {
        const handle = setInterval(() => {
            setDiff(calcDiff());
        }, 200);

        return () => clearInterval(handle);
    });

    return <React.Fragment>{formatInterval(diff)}</React.Fragment>;
}
